export const onlineOptions: { text: string; value: string; label: string }[] = [
  { text: 'Онлайн', value: 'online', label: 'Онлайн' },
  { text: 'Оффлайн', value: 'offline', label: 'Офлайн' },
  { text: 'Все', value: 'all', label: 'Все' }
].map((item) => ({ ...item, label: item.text }));
